
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { initSessionFromCallbackURI } from "../../actions"
import { Alert, Container } from 'reactstrap';

function mapStateToProps(state) {
    return {
        session: state.session,
        error: state.session.error
    }
}


class Callback extends Component {
    // If a Cognito auth code is in the URL (could be a hash or query component), init the new session
    componentDidMount() {
        if (this.props.location.hash || this.props.location.search) {
            this.props.initSessionFromCallbackURI(window.location.href)
        }
    }

    render() {

        // If there's no auth code in the URL or we're now logged into, redirect to the root page
        if ((!this.props.location.hash && !this.props.location.search) || this.props.session.isLoggedIn) {
            return <Redirect to="/order-create" />
        }
        return (
            <>
                {
                    (this.props.error) ?
                        (
                            <Container>
                            <div className="text-center mt-10">
                                <Alert color="danger ">
                                    <h1>Error</h1>
                                    <p>{this.props.error}</p>
                                </Alert>
                            </div>
                            </Container>)
                        : (<></>)
                }
            </>
        );
    }
}

export default connect(mapStateToProps, { initSessionFromCallbackURI: initSessionFromCallbackURI })(Callback)